import { IEnvSettings, IEnvInformation, Environment } from './authentication/authSettings';

const createEnvSettings = (baseSettings: {
    authority: string;
    apiBaseURL: string;
    portalUrl: string;
    historyUrl: string;
    fragmentsBaseUrl: string;
    clientSecret: string;
    environment: Environment;
    scope: string;
}): IEnvSettings => ({
    ...baseSettings,
    clientId: 'dxp-exp-console',
    blenderUrl: baseSettings.apiBaseURL + '/blender',
    contentManagerUrl: baseSettings.apiBaseURL + '/content',
    directoryManagerUrl: baseSettings.apiBaseURL + '/directory',
    gumUrl: baseSettings.apiBaseURL + '/usermanager/v2',
    customerManagerUrl: baseSettings.apiBaseURL + '/customer-manager/v3',
    chatHubUrl: baseSettings.apiBaseURL + '/chat/hub',
    emailHubUrl: baseSettings.apiBaseURL + '/email/hub',
    workflowManagerUrl: baseSettings.apiBaseURL + '/workflow'
});

const devSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth-dev.telxl.net',
    apiBaseURL: 'https://api-dev.telxl.net',
    portalUrl: 'https://portal-dev.telxl.net',
    historyUrl: 'https://odata-dev.telxl.net',
    fragmentsBaseUrl: 'https://cdn.telxl.net/dev-fragments/',
    clientSecret: '',
    environment: 'dev',
    scope:'gum bp.access openid profile email'
});

const qaSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth-qa.telxl.net',
    apiBaseURL: 'https://api-qa.telxl.net',
    portalUrl: 'https://portal-qa.telxl.net',
    historyUrl: 'https://odata-qa.telxl.net',
    fragmentsBaseUrl: 'https://cdn.telxl.net/qa-fragments/',
    clientSecret: '',
    environment: 'qa',
    scope:'gum bp.access openid profile email'
});

const sandboxSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth-sand.telxl.net',
    apiBaseURL: 'https://api-sand.telxl.net',
    portalUrl: 'https://portal-sand.telxl.net',
    historyUrl: 'https://odata-sand.telxl.net',
    fragmentsBaseUrl: 'https://cdn.telxl.net/sand-fragments/',
    clientSecret: '',
    environment: 'sandbox',
    scope:'gum bp.access openid profile email'
});

const prodSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth.telxl.net',
    apiBaseURL: 'https://api.telxl.net',
    portalUrl: 'https://portal.telxl.net',
    historyUrl: 'https://odata.telxl.net',
    fragmentsBaseUrl: 'https://cdn.telxl.net/prod-fragments/',
    clientSecret: '',
    environment: 'prod',
    scope:'gum bp.access openid profile email'
});

const hosts: Record<Environment, string> = {
    dev: 'dxp-experience-console-dev.telxl.net',
    qa: 'dxp-experience-console-qa.telxl.net',
    sandbox: 'dxp-experience-console-sand.telxl.net',
    prod: 'dxp-experience-console.telxl.net',
};

const hostMapping: { [key: string]: IEnvSettings } = {
    'localhost': devSettings,
    [hosts.dev]: devSettings,
    [hosts.qa]: qaSettings,
    [hosts.sandbox]: sandboxSettings,
    [hosts.prod]: prodSettings,
};

export function getEnvSettings(): IEnvInformation {
    const { hostname } = window.location;
    const envSettings = hostMapping[hostname];
    if (!envSettings) {
        if (window.self === window.top) { // to avoid console spam during auth
            // eslint-disable-next-line no-console
            console.warn(`Failed to determine environment settings based on '${hostname}' host. Dev settings will be used`);
        }
        return { ...devSettings, hostname };
    }
    return { ...hostMapping[hostname], hostname };
}

export function getHostFromEnvironment(env: Environment): string {
    return hosts[env];
}

